module.exports = __webpack_public_path__ + "website/img/618Vip.b40195fd.svg";